import { useDirectorsByCorporation } from '@commenda/api';
import { Icons } from '@commenda/kakashi';
import { WorkRequestResponseType } from '@commenda/types/src/work-request/types';
import { useState } from 'react';
import { SummaryFieldKS } from '../../../../incorporation/components/common';

export const USResponsibleParty = ({
  data,
}: {
  data: WorkRequestResponseType;
}) => {
  const { data: directorData } = useDirectorsByCorporation(
    data?.corporation?.id,
    '',
    { shouldIncludeSSN: true }
  );
  const [showSSN, setShowSSN] = useState(false);

  const responsibleParty = directorData?.find((director) => {
    return data?.corporation?.corporationHasDirector?.some(
      (corpHasDir) =>
        corpHasDir.directorId === director.id &&
        corpHasDir.additionalDirectorInformation?.isResponsibleParty
    );
  });

  if (!responsibleParty) {
    return (
      <div className="p-6 flex flex-col gap-2 bg-bg-disabled-subtle">
        <SummaryFieldKS heading="Responsible Party" value="Not assigned" />
      </div>
    );
  }

  return (
    <div className="p-6 flex flex-col gap-2 bg-bg-disabled-subtle">
      {responsibleParty.directorFirstName && (
        <SummaryFieldKS
          heading="First Name"
          value={responsibleParty.directorFirstName}
        />
      )}
      {responsibleParty.directorLastName && (
        <SummaryFieldKS
          heading="Last Name"
          value={responsibleParty.directorLastName}
        />
      )}
      {responsibleParty.email && (
        <SummaryFieldKS heading="Email" value={responsibleParty.email} />
      )}
      {responsibleParty.number && (
        <SummaryFieldKS
          heading="Phone Number"
          value={responsibleParty.number}
        />
      )}
      {responsibleParty.dateOfBirth && (
        <SummaryFieldKS
          heading="Date of Birth"
          value={responsibleParty.dateOfBirth}
        />
      )}
      {responsibleParty.operatingAddress &&
        (() => {
          const addressParts = [
            responsibleParty.operatingAddress.addressLine1,
            responsibleParty.operatingAddress.addressLine2,
            responsibleParty.operatingAddress.city,
            responsibleParty.operatingAddress.state,
            responsibleParty.operatingAddress.postalCode,
            responsibleParty.operatingAddress.country,
          ].filter(Boolean);

          if (addressParts.length === 0) return null;

          return (
            <SummaryFieldKS heading="Address" value={addressParts.join(', ')} />
          );
        })()}
      {responsibleParty.decryptedSSN && !responsibleParty.hasNoSSN && (
        <div className="flex justify-between items-start py-1 gap-4 border-b border-neutral-6">
          <span className="text-text-secondary flex-shrink-0 w-1/2">
            SSN/ITIN
          </span>
          <div className="text-neutral-1 text-left flex-grow w-2/3 flex items-center gap-2">
            <span>{showSSN ? responsibleParty.decryptedSSN : '•••••••••'}</span>
            <button
              type="button"
              onClick={() => setShowSSN(!showSSN)}
              className="p-1 hover:bg-bg-secondary-hover rounded transition-colors"
              title={showSSN ? 'Hide SSN' : 'Show SSN'}
            >
              {showSSN ? (
                <Icons.EyeOff className="w-4 h-4 text-text-tertiary" />
              ) : (
                <Icons.Eye className="w-4 h-4 text-text-tertiary" />
              )}
            </button>
          </div>
        </div>
      )}
      {responsibleParty.hasNoSSN && (
        <SummaryFieldKS heading="SSN/ITIN Status" value="No SSN/ITIN" />
      )}
    </div>
  );
};
